// extracted by mini-css-extract-plugin
export default {"logos":"Ndz-1BhWrwDbcp2jdj9U2A==","logo":"JKZngLelJqANvqsMc1MG3w=="};